import { InjectionToken } from '@angular/core';
import { Environment } from '@core/models';

export const APP_CONFIG = new InjectionToken('APP-CONFIG');
export const SSR_APP_CONFIG = new InjectionToken('SSR-APP-CONFIG');

export interface AppConfig {
  production: boolean;
  buildTime?: string;
  environment: Environment;
  siteName: string;
  keyVaultName?: string;
  apiUrl: string;
  storageUrl: string;
  clientId: string;
  cookieFirstId?: string;
  googleAnalyticsCode?: string;
  hotJarCode?: string;
  googleSearchConsoleId?: string;
  captchaSiteKey: string;
  butterApiUrl: string;
  butterSaltParam: string;
  upcomingEventVisibilityDayThreshold: number;
  useBetterstack: boolean;
  betterstackKeyVaultToken?: string;
}
